const EMAIL = /[^\s@]+@[^\s@]+\.[^\s@]+/g;
const URL = /\b(?:https?:\/\/|www\.)\S+/gi;
const LONG_DIGITS = /\+?\d[\d\s().-]{6,}\d/g;

const MAX_LENGTH = 120;

/**
 * Free text typed by a user, made safe to send as an event property. Verbatims
 * are readable in analytics but must not carry contact details, and event
 * properties (unlike person properties) never reach Customer.io profiles.
 */
export function sanitizeFreeText(value: string | null | undefined): string | undefined {
  if (value == null) return undefined;

  const cleaned = value
    .replace(EMAIL, '[email]')
    .replace(URL, '[url]')
    .replace(LONG_DIGITS, '[number]')
    .replace(/\s+/g, ' ')
    .trim();

  if (cleaned === '') return undefined;
  return cleaned.length > MAX_LENGTH ? `${cleaned.slice(0, MAX_LENGTH).trimEnd()}…` : cleaned;
}
